import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import DairyQuery from '~/QueryHooks/DairyQuery'
import Layout from '~/components/Layout'
import TypeCard from '~/components/TypeCard'

const ContractType: React.FC = () => {
  const { t } = useTranslation()
  const {
    isLoading: isBusyData,
    data: contractTypes,
    refetch: fetchData
  } = DairyQuery.getContractTypesList()

  useEffect(() => {
    fetchData()
  }, [t])

  const { rows } = contractTypes ? contractTypes : { rows: [] }

  return (
    <Layout
      title={t('Contract Types')}
      isBusy={isBusyData}
      childContainerSize={'auto'}
      fontSizeHeader={'18px'}
      useSpinner
    >
      <TypeCard rows={rows} />
    </Layout>
  )
}
export default ContractType
